module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "searchbar"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTxt),
      expression: "searchTxt"
    }],
    staticClass: "in-search",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.searchTxt)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.stopPropagation();
        return _vm.doSearch.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTxt = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "icon-search",
    attrs: {
      "href": "javascript:void(0);",
      "id": "btn_search"
    },
    on: {
      "click": _vm.doSearch
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a4e2058c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/v2/common/InSearch.vue
// module id = 105
// module chunks = 1